import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';

//Component
import { Provider } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { QueryClientProvider, QueryClient } from "react-query"
// import { rootReducer } from './reducers';
// import thunk from 'redux-thunk';
// import { createStore, applyMiddleware, compose } from 'redux';
import ReactGA from 'react-ga';
import { hotjar } from 'react-hotjar';
import CookieConsent from "react-cookie-consent";
import store from "./redux/store";

import "./api/axios.config"

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

const queryClient = new QueryClient()

class Root extends React.Component {
  componentDidMount() {
    ReactGA.initialize('UA-192829543-1');
    ReactGA.pageview("/accueil");
    hotjar.initialize('2338174', '6');

  }
  render() {
    const presistor = persistStore(store);
    // const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    // // const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
    return (
      <QueryClientProvider client={queryClient}>

        <Provider store={store}>
          <PersistGate loading={null} persistor={presistor}>
            <BrowserRouter>
              <Switch>
                <Route path="/" component={App} />
              </Switch>
            </BrowserRouter>
          </PersistGate>
          <CookieConsent
            location="bottom"
            buttonText="Accepter"
            cookieName="cookie-consent"
            style={{ background: "#222" }}
            buttonStyle={{ color: "#222", background: "#f8f9fa", fontSize: "13px" }}
            expires={150}
          >
            By using Falendi Platform, you agree to our Privacy Policy, including cookie policy.
          </CookieConsent>
        </Provider>
      </QueryClientProvider>

    );
  }
}

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorker.unregister();
